module.exports = __webpack_public_path__ + "static/img/KPH.e8436d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KPH.png
// module id = u7yn
// module chunks = 1